import { getTimezone } from 'countries-and-timezones';

export const prepareTimezones = (timeZones: Array<string>) =>
  timeZones
    .map(timeZone => {
      const parsedTimezone = getTimezone(timeZone);

      if (parsedTimezone?.countries.includes('RU')) {
        return null;
      }

      if (parsedTimezone) {
        const timezoneOffset = parsedTimezone.dstOffsetStr.slice(0, 3);
        const timezoneStr =
          timezoneOffset[1] === '0'
            ? timezoneOffset.replace('0', '')
            : timezoneOffset;
        return {
          label: `(GMT${timezoneStr}) ${timeZone}`,
          gmt: parseInt(timezoneStr),
          value: timeZone,
        };
      }

      return {
        label: timeZone,
        value: timeZone,
        gmt: 0,
      };
    })
    .filter(value => value !== null)
    .sort((a, b) => (a.gmt < b.gmt ? 1 : -1)) || [];

export const resolveDeviceTimeZone = (
  timeZones: Array<string>
): string | null => {
  const device = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!device) return null;
  if (timeZones.includes(device)) return device;

  const deviceAlias = getTimezone(device)?.aliasOf;
  if (deviceAlias && timeZones.includes(deviceAlias)) return deviceAlias;

  return (
    timeZones.find(timeZone => getTimezone(timeZone)?.aliasOf === device) ??
    null
  );
};
